<template>
<div class="section " :id="'suite-'+this.$router.currentRoute.params.name">
	<div class="container">
		<div class="columns">
			<article class="column">
				<img :src="'@/assets/cepSuites/'+this.$router.currentRoute.params.name+'.png'" :alt="'suite-'+this.$router.currentRoute.params.name">
				<h1 class="is-size-4"> Solución de Monitoreo de Cumplimiento </h1>
				<p>
					<b>La solución de Monitoreo de Cumplimiento de Ceptinel proporciona un sistema eficiente de detección de casos de AML, Financiamiento de Terrorismo y Abuso de mercado a través de monitoreo de datos. </b>
				</p>
			</article>
		</div>
		<div class="columns">
			<article class="column">
				<p>
					<ul>
						<li>Ceptinel puede detectar como ejemplo uso de información privilegiada de personas con acceso a datos sensibles, operaciones bursátiles en períodos de blackout, y alertas de Volcker-Rule. </li>
						<li>Permite cruzar información de transacciones de un operador y un cliente, personas relacionadas con información privilegiada, personas o entidades en listas negras, etc.</li>
						<li>El sistema detecta los casos en etapas iniciales, generando alertas de forma batch o en tiempo real</li>
						<li>Ceptinel ha logrado detectar múltiples casos de abuso o AML, evitando que el cliente tenga altas pérdidas por robos y corrupción interna así como la recepción de multas del regulador</li>
						<li>Evita situaciones que podrían generar un impacto reputacional negativo mucho mayor aún  que las propias multas. </li>
						<li>Permite dejar logs de auditoría, tanto para investigaciones posteriores como para demostrar debida diligencia al regulador</li>
						<li>Precisa, con implementación rápida y costo muy competitivo.</li>
					</ul>
				</p>
				<h5>Como Funciona</h5>
				<p>
					Se aplica reglas de negocio a través del Editor de reglas gráfico del sistema, generando alertas, listas y reportes.
					Tanto reglas propias propuestas por Ceptinel, como configurando reglas específicas de la empresa
				</p>
			</article>
			<aside class="column is-4">
				<b>El requerimiento urgente del cliente:</b>
				<p>
					- Con un volumen de datos creciendo en forma exponencial, los equipos de cumplimiento tienen que enfrentarse con el desafío de detectar los casos de AML, abuso de mercado y cumplimiento normativo que son difíciles de hallar mediante métodos y reportes tradicionales o se encuentran cuando es demasiado tarde.
				</p>
				<p>
					- Hoy las multas del regulador en casos que no se detecta AML y ATF son cada vez mayores, incluyendo presidio	
				</p>
				<b>Características </b>
				<ul>
					<li>Editor de reglas gráfico</li>
					<li>reglas automatizadas y customizables</li>
					<li>Múltiples fuentes de datos con fácil conexión e integración</li>
					<li>Generación de alertas e informes</li>
					<li>Detección de anomalías con Machine Learning</li>
					<li>Log de Auditoría</li>
					<li>Análisis de Documentos</li>
					<li>Agenda Normativa</li>
					<li>Canal de denuncias automatizada</li>
					<li>Alternativa Cloud o On-Premise</li>
				</ul>
			</aside>
		</div>
		<div class="columns">
			<div class="column">
				<h6>Competencia</h6>
				Las soluciones actuales son de costo mayor y ofrecen un nivel de flexibilidad más limitado en su workflow, donde cada modificación posterior a las reglas pre-definidas resulta costoso y demoroso
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: "suite",
  data() {
    return {};
  },
  computed: {
    suite() {
      return this.$t("solutions.items").filter((e) => {
        return e.link == this.$router.currentRoute.params.name;
      });
    },
  },
};
</script>